// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { Section, Div } from '@reuse';
import { Row, Column } from 'react-foundation';
import Breakpoint from 'react-socks';

// Styles
// ------
const Jacket = styled(Section)``;

const Space = styled(Div)`
    width: 100%;
    background-color: ${props => props.theme.bc1};
`;

// Component
// ------
const MortgageSplitter = () => (
    <Breakpoint medium up>
        <Jacket>
            <Row isExpanded isCollapsed>
                <Column small={12} large={11} pushOnLarge={1}>
                    <Space padBottom />
                </Column>
            </Row>
        </Jacket>
    </Breakpoint>
);

export default MortgageSplitter;
